export * from './organization/members/members.actions';
export * from './organization/members/members.models';
export * from './organization/members/members.state';
export * from './organization/organization.actions';
export * from './organization/organization.models';
export * from './organization/organization.state';
export * from './organization/activity/participant/participant.actions';
export * from './organization/activity/participant/participant.models';
export * from './organization/activity/participant/participant.state';
export * from './organization/activity/registration/registration.actions';
export * from './organization/activity/registration/registration.models';
export * from './organization/activity/registration/registration.state';
export * from './organization/activity/activity.actions';
export * from './organization/activity/activity.models';
export * from './organization/activity/activity.state';
export * from './toast/toast.actions';
export * from './toast/toast.models';
export * from './toast/toast.state';
export * from './dialog/dialog.actions';
export * from './dialog/dialog.models';
export * from './dialog/dialog.state';
export * from './account/account.actions';
export * from './account/account.models';
export * from './account/account.state';
export * from './admin/admin.actions';
export * from './admin/admin.models';
export * from './admin/admin.state';
export * from './support/support.actions';
export * from './support/support.models';
export * from './support/support.state';
export * from './serverEvents/serverEvents.actions';
export * from './serverEvents/serverEvents.models';
export * from './serverEvents/serverEvents.state';

export class PatchOperation {
  constructor(
    public op: string,
    public path: string,
    public value: unknown
  ) {}
}
